import React from 'react';
import PropTypes from 'prop-types';

import { Paragraph } from 'components/core/Typography';
import { Card } from 'components/legacy/Card';
import { FacilityCard } from 'components/facility/FacilityCard';
import { SearchBox } from 'components/search/SearchBox';
import MapPin from 'components/svg/MapPin';

export function NearbyFacilities({
	facilities,
	getFacilityCardPhoneNumber,
	handleSearch,
	location,
	withUnits,
	handleFacilityCardVisible,
	baseUrl,
	cloudfrontUrl,
}) {
	return (
		<Card
			className="nearby-facilities"
			header="Nearby Storage Facilities"
		>
			{facilities.map((facility) => (
				<FacilityCard
					key={facility.id}
					facility={facility}
					withUnits={withUnits}
					storageType="storage"
					getFacilityCardPhoneNumber={() =>
						getFacilityCardPhoneNumber(
							facility.location.city,
							facility.location.state,
							facility.id,
						)
					}
					onVisible={handleFacilityCardVisible}
					baseUrl={baseUrl}
					cloudfrontUrl={cloudfrontUrl}
				/>
			))}
			{!facilities.length && !!location && (
				<div className="card-content">
					<Paragraph>
						We couldn't find any nearby facilities. Would you like
						to search again?
					</Paragraph>
					<SearchBox
						onSearch={handleSearch}
						icon={<MapPin fill="gray" />}
						location={`${location.city}, ${location.state}`}
						useBrowserLocation
					/>
				</div>
			)}
		</Card>
	);
}

NearbyFacilities.propTypes = {
	facilities: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
	getFacilityCardPhoneNumber: PropTypes.func.isRequired,
	handleSearch: PropTypes.func,
	location: PropTypes.shape({
		city: PropTypes.string.isRequired,
		state: PropTypes.string.isRequired,
	}),
	withUnits: PropTypes.bool,
	handleFacilityCardVisible: PropTypes.func,
	baseUrl: PropTypes.string,
	cloudfrontUrl: PropTypes.string,
};

export default NearbyFacilities;
